import type { Patient } from 'fhir/r4';
import { Card, Image, Label, Popup } from 'semantic-ui-react';

import { useAuthContext } from '../../../contexts/AuthContext';
import * as FHIRUtils from '../../../utils/FHIRUtils';
import * as Helpers from '../../../utils/Helpers';
import { formatPhoneNumber } from '../../../utils/utils';

import MemberQuickInfo from './quickinfo';

/**
 * What the four `list/*` screens pass. They each hold their rows as `PatientEntry[]`
 * and hand down `entry.resource`, whose declared type is `PatientResource`
 * (`Patient & { id: string }`) — so `patient` is always present here.
 */
interface MemberCardProps {
  patient: Patient;
  onPatientSelect: (patient: Patient) => void;
}

function MemberCard(props: MemberCardProps) {
  const _authInfo = useAuthContext();

  const fhirPatient: Patient = props.patient;
  const flatPatient = FHIRUtils.parseFHIRPatient(fhirPatient);
  let imageName = 'neutral.png';
  if (flatPatient.gender) {
    imageName = Helpers.getImage(flatPatient.gender === 'male', flatPatient?.fullName);
  }

  return (
    <Popup
      flowing
      hoverable
      style={{ zIndex: '99999' }}
      trigger={
        <Card link={true} onClick={() => props.onPatientSelect(fhirPatient)}>
          <Card.Content>
            <Image floated="left" size="mini" src={'/images/' + imageName} />
            <Card.Header>
              {flatPatient.firstName} {flatPatient.lastName}
            </Card.Header>
            <Card.Meta>
              {flatPatient.mobilePhone[0] && flatPatient.mobilePhone[0] !== '' && (
                <>{formatPhoneNumber(flatPatient.mobilePhone)}</>
              )}

              {(!flatPatient.mobilePhone[0] || flatPatient.mobilePhone[0] === '') &&
                flatPatient.homePhone[0] &&
                flatPatient.homePhone[0] !== '' && <>{formatPhoneNumber(flatPatient.homePhone)}</>}
            </Card.Meta>
            <Card.Description>
              <Label>{`${flatPatient?.genderPrefix}  ${flatPatient.age}`}</Label>
              <Label>{flatPatient.dob}</Label>
              {flatPatient?.memberId?.length > 0 && <Label>{flatPatient?.memberId}</Label>}
              <Label style={{ marginTop: '3px' }}>{flatPatient.id}</Label>
            </Card.Description>
          </Card.Content>
        </Card>
      }
    >
      <Popup.Content>
        <MemberQuickInfo patient={fhirPatient} />
      </Popup.Content>
    </Popup>
  );
}

export default MemberCard;
